// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    overflow: visible !important;
  
}
textarea::-webkit-scrollbar {
  width: 8px;
}

textarea::-webkit-scrollbar-track {
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
  
}

textarea:where([data-bs-theme="dark"], [data-bs-theme="dark"] *)::-webkit-scrollbar-track {
    --tw-bg-opacity: 1;
    background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
  
}

textarea::-webkit-scrollbar-thumb {
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
  
}

textarea:where([data-bs-theme="dark"], [data-bs-theme="dark"] *)::-webkit-scrollbar-thumb {
    --tw-bg-opacity: 1;
    background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
  
}

textarea::-webkit-scrollbar-thumb:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
  
}

textarea:where([data-bs-theme="dark"], [data-bs-theme="dark"] *)::-webkit-scrollbar-thumb:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
  
}

/* Smooth transitions for custom elements */
.smooth-transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/* Enhanced focus states */
button:focus-visible {
    outline-width: 2px;
    outline-offset: 2px;
    outline-color: hsl(216, 98%, 52%);
  
}

textarea:focus-visible {
    outline: 2px solid transparent;
    outline-offset: 2px;
  
}

/* Animation keyframes */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes successPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

/* Apply animations */
.group {
  animation: fadeInScale 0.2s ease-out;
}

.group\\/content:hover .absolute {
  animation: slideInUp 0.2s ease-out;
}

/* Dark mode improvements */
@media (prefers-color-scheme: dark) {
  .bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, rgb(15 23 42), rgb(30 41 59 / 0.3), rgb(49 46 129 / 0.2));
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .border-slate-200\\/60 {
        --tw-border-opacity: 1;
        border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
  
    }
  
  .text-slate-500 {
        --tw-text-opacity: 1;
        color: rgb(71 85 105 / var(--tw-text-opacity, 1));
  
    }
  
  .bg-gradient-to-r {
        --tw-bg-opacity: 1;
        background-color: hsl(219 98% 44% / var(--tw-bg-opacity, 1));
  
    }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  
  .animate-spin,
  .animate-pulse,
  .animate-bounce {
    animation: none !important;
  }
}

/* Mobile responsive improvements */
@media (max-width: 640px) {
  .group {
        border-radius: 0.5rem;
  
    }
  
  .px-5 {
        padding-left: 1rem;
        padding-right: 1rem;
  
    }
  
  .py-5 {
        padding-top: 1rem;
        padding-bottom: 1rem;
  
    }
  
  /* Stack action buttons on mobile */
  .flex.items-center.gap-1 {
        flex-wrap: wrap;
        gap: 0.5rem;
  
    }
}

/* Loading state improvements */
.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Backdrop blur fallback */
@supports not (backdrop-filter: blur(8px)) {
  .backdrop-blur-sm {
        background-color: rgb(255 255 255 / 0.9);
  
    }
  .backdrop-blur-sm:where([data-bs-theme="dark"], [data-bs-theme="dark"] *) {
        background-color: rgb(15 23 42 / 0.9);
  
    }
}

/* Print styles */
@media print {
  .group {
        border-width: 1px;
        --tw-border-opacity: 1;
        border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
        --tw-shadow: 0 0 #0000;
        --tw-shadow-colored: 0 0 #0000;
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  
    }
  
  button,
  .absolute {
        display: none;
  
    }
  
  .text-slate-700 {
        --tw-text-opacity: 1;
        color: rgb(0 0 0 / var(--tw-text-opacity, 1));
  
    }
}

/* Accessibility improvements */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Focus indicators for keyboard navigation */
button:focus-visible,
textarea:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    --tw-ring-opacity: 1;
    --tw-ring-color: hsl(216 98% 52% / var(--tw-ring-opacity, 1));
    --tw-ring-offset-width: 2px;
    --tw-ring-offset-color: #fff;
  
}
button:focus-visible:where([data-bs-theme="dark"], [data-bs-theme="dark"] *),
textarea:focus-visible:where([data-bs-theme="dark"], [data-bs-theme="dark"] *) {
    --tw-ring-offset-color: #0f172a;
  
}

/* High contrast border improvements */
@media (prefers-contrast: high) {
  .border-slate-200\\/60 {
        --tw-border-opacity: 1;
        border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
  
    }
  
  .border-slate-700\\/60 {
        --tw-border-opacity: 1;
        border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
  
    }
}

/* Selection styles */
::selection {
    --tw-bg-opacity: 1;
    background-color: hsl(214 100% 92% / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: hsl(222 97% 20% / var(--tw-text-opacity, 1));
  
}

::-moz-selection {
    --tw-bg-opacity: 1;
    background-color: hsl(214 100% 92% / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: hsl(222 97% 20% / var(--tw-text-opacity, 1));
  
}

/* Custom properties for theme consistency */
:root {
  --ai-field-primary: hsl(219, 98%, 44%);
  --ai-field-primary-light: hsl(215, 100%, 96%);
  --ai-field-border: #e2e8f0;
  --ai-field-text: #0f172a;
  --ai-field-text-muted: #475569;
  --ai-field-bg: #fff;
  --ai-field-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

[data-theme="dark"] {
  --ai-field-primary: hsl(214, 97%, 62%);
  --ai-field-primary-light: hsl(222, 97%, 16%);
  --ai-field-border: #334155;
  --ai-field-text: #f1f5f9;
  --ai-field-text-muted: #94a3b8;
  --ai-field-bg: #0f172a;
  --ai-field-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
}

/* Micro-interactions */
.group:hover .group\\/btn {
    --tw-scale-x: 1.05;
    --tw-scale-y: 1.05;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  
}

.group\\/btn:active {
    --tw-scale-x: .95;
    --tw-scale-y: .95;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-duration: 75ms;
  
}

/* Gradient animations */
@keyframes gradientShift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.group:hover .bg-gradient-to-r {
  background-size: 200% 200%;
  animation: gradientShift 3s ease infinite;
}

/* Loading spinner improvements */
.loading-spinner {
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Tooltip styles (if needed for future enhancements) */
.tooltip {
    pointer-events: none;
    position: absolute;
    z-index: 50;
    border-radius: 0.375rem;
    --tw-bg-opacity: 1;
    background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    opacity: 0;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 200ms;
  
}
.group\\/content:hover .tooltip {
  animation: slideInUp 0.2s ease-out;
}
@media print {
  
  .tooltip {
        display: none;
  
    }
}

.tooltip.show {
    opacity: 1;
  
}

/* Status indicators */
.status-dot {
    height: 0.5rem;
    width: 0.5rem;
    border-radius: 9999px;
  
}

@keyframes pulse {
    50% {
        opacity: .5;
  
    }
  
}

.status-dot.generating {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    --tw-bg-opacity: 1;
    background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
  
}

@media (prefers-reduced-motion: reduce) {
  
  .status-dot.generating {
    animation: none;
  }
}

.status-dot.success {
    --tw-bg-opacity: 1;
    background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
  
}

.status-dot.error {
    --tw-bg-opacity: 1;
    background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
  
}

/* Content fade animations */
.content-fade-enter {
  opacity: 0;
  transform: translateY(4px);
}

.content-fade-enter-active {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 200ms ease-out, transform 200ms ease-out;
}

.content-fade-exit {
  opacity: 1;
  transform: translateY(0);
}

.content-fade-exit-active {
  opacity: 0;
  transform: translateY(-4px);
  transition: opacity 150ms ease-in, transform 150ms ease-in;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/course-ai-field/course-ai-field.component.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;;AAEhC;AACA;EACE,UAAU;AACZ;;AAGE;IAAA,uBAAgD;IAAhD,kBAAgD;IAAhD,4DAAA;;AAAgD;;AAAhD;IAAA,kBAAgD;IAAhD,yDAAA;;AAAgD;;AAIhD;IAAA,uBAAgD;IAAhD,kBAAgD;IAAhD,4DAAA;;AAAgD;;AAAhD;IAAA,kBAAgD;IAAhD,0DAAA;;AAAgD;;AAIhD;IAAA,kBAAqC;IAArC,4DAAA;;AAAqC;;AAArC;IAAA,kBAAqC;IAArC,4DAAA;;AAAqC;;AAGvC,2CAA2C;AAC3C;EACE,wJAAwJ;EACxJ,wDAAwD;AAC1D;;AAEA,0BAA0B;AAExB;IAAA,kBAAqD;IAArD,mBAAqD;IAArD,iCAAA;;AAAqD;;AAIrD;IAAA,8BAAmB;IAAnB,mBAAA;;AAAmB;;AAGrB,wBAAwB;AACxB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE;IACE,4GAA4G;EAC9G;AACF;;AAEA,+BAA+B;AAC/B;EAEI;QAAA,sBAAuB;QAAvB,4DAAA;;IAAuB;;EAIvB;QAAA,oBAAqB;QAArB,iDAAA;;IAAqB;;EAIrB;QAAA,kBAAqB;QAArB,4DAAA;;IAAqB;AAEzB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA,mCAAmC;AACnC;EAEI;QAAA,qBAAA;;IAAiB;;EAIjB;QAAA,kBAAW;QAAX,mBAAA;;IAAW;;EAIX;QAAA,iBAAW;QAAX,oBAAA;;IAAW;;EAGb,mCAAmC;EAEjC;QAAA,eAAsB;QAAtB,WAAA;;IAAsB;AAE1B;;AAEA,+BAA+B;AAC/B;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EAEI;QAAA,wCAAA;;IAAuC;EAAvC;QAAA,qCAAA;;IAAuC;AAE3C;;AAEA,iBAAiB;AACjB;EAEI;QAAA,iBAAyC;QAAzC,sBAAyC;QAAzC,4DAAyC;QAAzC,sBAAyC;QAAzC,8BAAyC;QAAzC,uGAAA;;IAAyC;;EAKzC;;QAAA,aAAA;;IAAa;;EAIb;QAAA,oBAAiB;QAAjB,6CAAA;;IAAiB;AAErB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,6CAA6C;AAG3C;;IAAA,2GAAyF;IAAzF,yGAAyF;IAAzF,4FAAyF;IAAzF,oBAAyF;IAAzF,6DAAyF;IAAzF,2BAAyF;IAAzF,4BAAA;;AAAyF;AAAzF;;IAAA,+BAAA;;AAAyF;;AAG3F,sCAAsC;AACtC;EAEI;QAAA,sBAAuB;QAAvB,0DAAA;;IAAuB;;EAIvB;QAAA,sBAAuB;QAAvB,4DAAA;;IAAuB;AAE3B;;AAEA,qBAAqB;AAEnB;IAAA,kBAAsC;IAAtC,6DAAsC;IAAtC,oBAAsC;IAAtC,mDAAA;;AAAsC;;AAItC;IAAA,kBAAsC;IAAtC,6DAAsC;IAAtC,oBAAsC;IAAtC,mDAAA;;AAAsC;;AAGxC,4CAA4C;AAC5C;EACE,sCAA+C;EAC/C,6CAAoD;EACpD,0BAA4C;EAC5C,wBAA0C;EAC1C,8BAAgD;EAChD,mBAAoC;EACpC,gDAAwC;AAC1C;;AAEA;EACE,sCAA+C;EAC/C,4CAAqD;EACrD,0BAA4C;EAC5C,wBAA0C;EAC1C,8BAAgD;EAChD,sBAAwC;EACxC,qFAAwC;AAC1C;;AAEA,uBAAuB;AAErB;IAAA,kBAAgB;IAAhB,kBAAgB;IAAhB,+LAAA;;AAAgB;;AAIhB;IAAA,iBAAe;IAAf,iBAAe;IAAf,+LAAe;EACf,yBAAA;;AADe;;AAIjB,wBAAwB;AACxB;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,uDAAuD;AAErD;IAAA,oBAA4J;IAA5J,kBAA4J;IAA5J,WAA4J;IAA5J,uBAA4J;IAA5J,kBAA4J;IAA5J,yDAA4J;IAA5J,oBAA4J;IAA5J,qBAA4J;IAA5J,oBAA4J;IAA5J,uBAA4J;IAA5J,kBAA4J;IAA5J,iBAA4J;IAA5J,gBAA4J;IAA5J,oBAA4J;IAA5J,mDAA4J;IAA5J,UAA4J;IAA5J,+EAA4J;IAA5J,mGAA4J;IAA5J,uGAA4J;IAA5J,4BAA4J;IAA5J,wDAA4J;IAA5J,0BAAA;;AAA4J;AAA5J;EAAA,kCAA4J;AAAA;AAA5J;;EAAA;QAAA,aAAA;;IAA4J;AAAA;;AAI5J;IAAA,UAAA;;AAAkB;;AAGpB,sBAAsB;AAEpB;IAAA,cAA2B;IAA3B,aAA2B;IAA3B,qBAAA;;AAA2B;;AAI3B;IAAA;QAAA,WAAA;;IAAkC;;AAAA;;AAAlC;IAAA,yDAAkC;IAAlC,kBAAkC;IAAlC,2DAAA;;AAAkC;;AAAlC;;EAAA;IAAA,eAAkC;EAAA;AAAA;;AAIlC;IAAA,kBAAmB;IAAnB,2DAAA;;AAAmB;;AAInB;IAAA,kBAAiB;IAAjB,4DAAA;;AAAiB;;AAGnB,4BAA4B;AAC5B;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,4DAA4D;AAC9D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,0DAA0D;AAC5D;AAmJA,gqZAAgqZ","sourcesContent":[":host {\n    overflow: visible !important;\n  \n}\ntextarea::-webkit-scrollbar {\n  width: 8px;\n}\n\ntextarea::-webkit-scrollbar-track {\n  @apply bg-slate-100 dark:bg-slate-700 rounded-md;\n}\n\ntextarea::-webkit-scrollbar-thumb {\n  @apply bg-slate-300 dark:bg-slate-600 rounded-md;\n}\n\ntextarea::-webkit-scrollbar-thumb:hover {\n  @apply bg-slate-400 dark:bg-slate-500;\n}\n\n/* Smooth transitions for custom elements */\n.smooth-transition {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Enhanced focus states */\nbutton:focus-visible {\n  @apply outline-2 outline-offset-2 outline-primary-500;\n}\n\ntextarea:focus-visible {\n  @apply outline-none;\n}\n\n/* Animation keyframes */\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes successPulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.1);\n    opacity: 0.8;\n  }\n}\n\n/* Apply animations */\n.group {\n  animation: fadeInScale 0.2s ease-out;\n}\n\n.group\\/content:hover .absolute {\n  animation: slideInUp 0.2s ease-out;\n}\n\n/* Dark mode improvements */\n@media (prefers-color-scheme: dark) {\n  .bg-gradient-to-br {\n    background-image: linear-gradient(to bottom right, rgb(15 23 42), rgb(30 41 59 / 0.3), rgb(49 46 129 / 0.2));\n  }\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .border-slate-200\\/60 {\n    @apply border-slate-400;\n  }\n  \n  .text-slate-500 {\n    @apply text-slate-600;\n  }\n  \n  .bg-gradient-to-r {\n    @apply bg-primary-600;\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n  \n  .animate-spin,\n  .animate-pulse,\n  .animate-bounce {\n    animation: none !important;\n  }\n}\n\n/* Mobile responsive improvements */\n@media (max-width: 640px) {\n  .group {\n    @apply rounded-lg;\n  }\n  \n  .px-5 {\n    @apply px-4;\n  }\n  \n  .py-5 {\n    @apply py-4;\n  }\n  \n  /* Stack action buttons on mobile */\n  .flex.items-center.gap-1 {\n    @apply flex-wrap gap-2;\n  }\n}\n\n/* Loading state improvements */\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Backdrop blur fallback */\n@supports not (backdrop-filter: blur(8px)) {\n  .backdrop-blur-sm {\n    @apply bg-white/90 dark:bg-slate-900/90;\n  }\n}\n\n/* Print styles */\n@media print {\n  .group {\n    @apply shadow-none border border-gray-300;\n  }\n  \n  button,\n  .absolute {\n    @apply hidden;\n  }\n  \n  .text-slate-700 {\n    @apply text-black;\n  }\n}\n\n/* Accessibility improvements */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Focus indicators for keyboard navigation */\nbutton:focus-visible,\ntextarea:focus-visible {\n  @apply ring-2 ring-offset-2 ring-primary-500 ring-offset-white dark:ring-offset-slate-900;\n}\n\n/* High contrast border improvements */\n@media (prefers-contrast: high) {\n  .border-slate-200\\/60 {\n    @apply border-slate-600;\n  }\n  \n  .border-slate-700\\/60 {\n    @apply border-slate-300;\n  }\n}\n\n/* Selection styles */\n::selection {\n  @apply bg-primary-100 text-primary-900;\n}\n\n::-moz-selection {\n  @apply bg-primary-100 text-primary-900;\n}\n\n/* Custom properties for theme consistency */\n:root {\n  --ai-field-primary: theme('colors.primary.600');\n  --ai-field-primary-light: theme('colors.primary.50');\n  --ai-field-border: theme('colors.slate.200');\n  --ai-field-text: theme('colors.slate.900');\n  --ai-field-text-muted: theme('colors.slate.600');\n  --ai-field-bg: theme('colors.white');\n  --ai-field-shadow: theme('boxShadow.sm');\n}\n\n[data-theme=\"dark\"] {\n  --ai-field-primary: theme('colors.primary.400');\n  --ai-field-primary-light: theme('colors.primary.950');\n  --ai-field-border: theme('colors.slate.700');\n  --ai-field-text: theme('colors.slate.100');\n  --ai-field-text-muted: theme('colors.slate.400');\n  --ai-field-bg: theme('colors.slate.900');\n  --ai-field-shadow: theme('boxShadow.lg');\n}\n\n/* Micro-interactions */\n.group:hover .group\\/btn {\n  @apply scale-105;\n}\n\n.group\\/btn:active {\n  @apply scale-95;\n  transition-duration: 75ms;\n}\n\n/* Gradient animations */\n@keyframes gradientShift {\n  0%, 100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n.group:hover .bg-gradient-to-r {\n  background-size: 200% 200%;\n  animation: gradientShift 3s ease infinite;\n}\n\n/* Loading spinner improvements */\n.loading-spinner {\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Tooltip styles (if needed for future enhancements) */\n.tooltip {\n  @apply absolute z-50 px-2 py-1 text-xs font-medium text-white bg-gray-900 rounded-md shadow-lg pointer-events-none opacity-0 transition-opacity duration-200;\n}\n\n.tooltip.show {\n  @apply opacity-100;\n}\n\n/* Status indicators */\n.status-dot {\n  @apply w-2 h-2 rounded-full;\n}\n\n.status-dot.generating {\n  @apply bg-yellow-400 animate-pulse;\n}\n\n.status-dot.success {\n  @apply bg-green-400;\n}\n\n.status-dot.error {\n  @apply bg-red-400;\n}\n\n/* Content fade animations */\n.content-fade-enter {\n  opacity: 0;\n  transform: translateY(4px);\n}\n\n.content-fade-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 200ms ease-out, transform 200ms ease-out;\n}\n\n.content-fade-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.content-fade-exit-active {\n  opacity: 0;\n  transform: translateY(-4px);\n  transition: opacity 150ms ease-in, transform 150ms ease-in;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
